import { createContext } from "react";
export const CdpConfigContext = createContext(null);
export const CdpConfigProvider = CdpConfigContext.Provider;
